import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import useTargetCamera from "./useTargetCamera";
import {optionAction} from "../../redux/store";

export const useShootingPoint = (code, linkPath) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {shootingPointChange} = useTargetCamera();

  const dataSub = useSelector(state => state.optionWindow.dataSub);
  const connectMode = useSelector(state => state.theme.connectMode);

  const shootingPointChangeHandler = (e, stepObject, target) => {
    if (connectMode === "web") {
      navigate(`../${linkPath}`, { relative: 'path' });
    }

    shootingPointChange(stepObject, target);

    if(e.target.id !== "delete_button") {
      dispatch(optionAction.setCurrentStep({id: stepObject.id, code: code}));
    }

    const reg = /[\{\}\[\]\/?.,;:|\)*~`!^\+<>@\#$%&\\\=\(\'\"]/gi;
    const replaceLinkPath = linkPath.replaceAll(reg, "");

    if(linkPath && !dataSub) {
      dispatch(optionAction.setCurrentNavigation(replaceLinkPath));
    }
  };

  return {
    shootingPointChangeHandler
  };
};
